<ion-header>
    <ion-toolbar>
        <ion-title>{{ i18n.tr('Artikel Ontvangen') }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()"> {{ i18n.tr('[en]Close') }} </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div *ngIf="isLoading" class="ion-text-center ion padding">
        <ion-spinner> </ion-spinner>
    </div>

    <div *ngIf="!isLoading && details">
        <ion-card>
            <ion-card-header>
                <ion-card-title> {{details.POLdescr}} </ion-card-title>
                <ion-card-subtitle>
                    <span class="artikel-label">{{ i18n.tr('Art. Nr') }}:&nbsp;</span>
                    <span class="artikel-number">{{details.POLartnr}}</span>
                </ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
                <ion-grid>
                    <ion-row>
                        <ion-col size="4" class="detail-label"
                            >{{ i18n.tr('Locatie') }}:</ion-col
                        >
                        <ion-col size="8" class="detail-value locatie"
                            >{{details.Locatie || 'N/A'}}</ion-col
                        >
                    </ion-row>
                    <ion-row>
                        <ion-col size="4" class="detail-label"
                            >{{ i18n.tr('Besteld') }}:</ion-col
                        >
                        <ion-col size="8" class="detail-value besteld"
                            >{{details.Besteld}}</ion-col
                        >
                    </ion-row>
                    <ion-row>
                        <ion-col size="4" class="detail-label"
                            >{{ i18n.tr('Ontvangen') }}:</ion-col
                        >
                        <ion-col size="8" class="detail-value ontvangen"
                            >{{details.Ontvangen}}</ion-col
                        >
                    </ion-row>
                    <ion-row>
                        <ion-col size="4" class="detail-label"
                            >{{ i18n.tr('Eenheid') }}:</ion-col
                        >
                        <ion-col size="8" class="detail-value eenheid"
                            >{{details.Eenheid}}</ion-col
                        >
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>
        <div class="input-container">
            <ion-item fill="outline">
                <ion-label position="floating">{{ i18n.tr('Aantal ontvangen') }}</ion-label>
                <ion-input
                    type="number"
                    [(ngModel)]="receivedQty"
                    [placeholder]="i18n.tr('Aantal')"
                    clearInput
                >
                </ion-input>
            </ion-item>
            <ion-button
                class="fill-button"
                fill="outline"
                (click)="fillRemaining()"
            >
                <ion-icon slot="start" name="calculator-outline"></ion-icon>
                <!-- Alles geleverd -->
                {{ i18n.tr('Vul restant in') }}
            </ion-button>
        </div>
    </div>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button expand="block" (click)="save()" [disabled]="!receivedQty">
            {{ i18n.tr('[en]Save') }}
        </ion-button>
    </ion-toolbar>
</ion-footer>
